var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "columns" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "b-breadcrumb",
          { attrs: { size: "is-small" } },
          [
            _c(
              "b-breadcrumb-item",
              { attrs: { tag: "router-link", to: "/" } },
              [_vm._v(" " + _vm._s(_vm.$t("home")) + " ")]
            ),
            _c(
              "b-breadcrumb-item",
              { attrs: { tag: "router-link", to: { name: "evaluations" } } },
              [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
            ),
            _vm._l(_vm.links, function (link) {
              return _c(
                "b-breadcrumb-item",
                {
                  key: link.label,
                  attrs: {
                    tag: "router-link",
                    to: link.to,
                    active: link.active,
                  },
                },
                [_vm._v(" " + _vm._s(link.label) + " ")]
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }